module.exports = __webpack_public_path__ + "img/values_pic.dc03e914.jpg";